import { Global } from '@emotion/react';
import { MainAreaSlotV2 } from '@libs/templates/page-layout-v2';
import { designTokensRootStyle } from '@libs/ui';
import { Outlet } from 'react-router';

/**
 * 業務コンテンツの枠。
 *
 * 初期段階の構成にはサブメニュー（業務メニューサイドバー）を含まないため、ロケーション表示・
 * サイドバーは持たない。design tokens の注入と業務コンテンツの寸法確保だけを担う。
 *
 * 既存FA画面が通る `ContainerWithContext` とは別のコンテナに置く。既存画面は ppfw-client の
 * `Template`（枠線・影・`calcViewAreaHeight()` による高さの実測）を各画面で描いているので、
 * 共通のコンテナに入れると v2 の枠と二重になる。適用先を route 単位で選べる形にしておく。
 */
export function BusinessShellV2() {
  return (
    <>
      {/*
        design tokens の宣言はここで注入する。新UI（v2）を組むのはこの枠だけなので、
        全画面の起点（`RootContainer`）ではなく使う側に置く。
      */}
      <Global styles={designTokensRootStyle} />
      <MainAreaSlotV2>
        <Outlet />
      </MainAreaSlotV2>
    </>
  );
}
